import { render, staticRenderFns } from "./GTextarea.vue?vue&type=template&id=228f0420&scoped=true&"
import script from "./GTextarea.vue?vue&type=script&lang=ts&"
export * from "./GTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./GTextarea.vue?vue&type=style&index=0&id=228f0420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f0420",
  null
  
)

export default component.exports